import { render, staticRenderFns } from "./number-group-sheet.vue?vue&type=template&id=012dd388&scoped=true"
import script from "./number-group-sheet.vue?vue&type=script&lang=js"
export * from "./number-group-sheet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012dd388",
  null
  
)

/* custom blocks */
import block0 from "./number-group-sheet.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports